import React from 'react';
import { useTranslation } from 'react-i18next';

const EditRecurrenceModal = ({ onChoice, onClose }) => {
  const { t } = useTranslation();
  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 7000,
    }}>
      <div style={{
        background: 'var(--bg-color, #fff)', borderRadius: 12, padding: 24,
        maxWidth: 360, width: '100%', display: 'flex', flexDirection: 'column', gap: 10,
        boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
      }}>
        <h4 style={{ margin: 0, fontSize: 15 }}>{t('agenda.edit_recurrence_title')}</h4>

        {[
          { mode: 'this',      label: t('agenda.edit_this') },
          { mode: 'following', label: t('agenda.edit_following') },
          { mode: 'all',       label: t('agenda.edit_all') },
        ].map(({ mode, label }) => (
          <button key={mode} onClick={() => onChoice(mode)} style={{
            padding: '10px', borderRadius: 8, border: '1px solid #ccc',
            background: 'none', cursor: 'pointer', textAlign: 'left',
            color: 'var(--text-color)',
          }}>
            {label}
          </button>
        ))}

        <button onClick={onClose} style={{
          marginTop: 4, background: 'none', border: 'none',
          cursor: 'pointer', color: '#888', fontSize: 13,
        }}>
          {t('agenda.annuler')}
        </button>
      </div>
    </div>
  );
};

export default EditRecurrenceModal;